import AccountingDocumentState from "../shared/documentInfrastructure/AccountingDocumentState.js";

/**
 * Hold and manage the state for the forecast archive document.
 *
 * @param {boolean} canCurrentUserDeleteForecasts - Must be truthy
 *   when the current user should see a delete button next to each
 *   forecast
 */
export default class ForecastArchiveDocumentState extends AccountingDocumentState {
	constructor({ canCurrentUserDeleteForecasts }) {
		super(...arguments);

		this._canCurrentUserDeleteForecasts = canCurrentUserDeleteForecasts;
	}

	getPublishedForecastSource() {
		return this._publishedForecastSource;
	}

	canForecastBeDeleted() {
		return this._canCurrentUserDeleteForecasts;
	}

	deleteForecast(...rest) {
		return this._service.deleteForecast(...rest);
	}

	async toggleEstimateTag({ forecast }) {
		forecast.setIsEstimate(
			await (forecast.isEstimate()
				? this.untagForecastAsEstimate(forecast)
				: this.tagForecastAsEstimate(forecast)),
		);
	}

	tagForecastAsEstimate(...rest) {
		return this._service.tagForecastAsEstimate(...rest);
	}

	untagForecastAsEstimate(...rest) {
		return this._service.untagForecastAsEstimate(...rest);
	}

	_setupInitialData({ publishedForecastSource }) {
		this._publishedForecastSource = publishedForecastSource;
	}
}
